import api from "./services/api"
import { INVITE_STATUS } from "./constants/inviteStatus"
import { PLAN_USER_ROLE } from "./constants/planUserRole"
import { PLAN_STATUS } from "./constants/planStatus"
import { isStepLocked } from "./lib/plan"

export const setPlanContent = (planToken, keys, setData) => {
  api.getPlanContent(planToken, keys).then(response => {
    setData({
      ...keys.reduce((acc, key) => {
        acc[key] = response.data.filter(item => item.key == key).flatMap(item => item.value)
        return acc
      }, {}),
    })
  })
}

/**
 * Generates navigation links for a plan based on user's role and invitation status
 * @param {Object} plan - Plan object with current_user_role and current_user_invitation_status
 * @returns {Array} Array of link objects with label and path properties
 */
export const generatePlanLinks = plan => {
  const links = []

  if (!isStepLocked(PLAN_STATUS.SEND_PLAN, plan.status)) {
    links.push({ label: "Download Plan", path: `/plan/${plan.token}/download` })
  }

  if (plan.current_user_invitation_status === INVITE_STATUS.PENDING) {
    return [{ label: "Accept Invitation", path: `/plan/${plan.token}/invitation` }, ...links]
  }

  // current_user_role is now an array - check if ANY role qualifies
  const roles = plan.current_user_role ?? []

  if (roles.some(r => r === PLAN_USER_ROLE.GUIDE)) {
    return [
      { label: "Set Up Checklist", path: `/plan/${plan.token}/checklist` },
      { label: "Activities", path: `/plan/${plan.token}/activities` },
      ...links,
    ]
  }

  if (roles.some(r => r === PLAN_USER_ROLE.INITIATOR)) {
    return [{ label: "Set Up Checklist", path: `/plan/${plan.token}/checklist` }, ...links]
  }

  return [
    { label: "Activities", path: `/plan/${plan.token}/activities` },
    ...links,
  ]
}


export function toUppercaseFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .slice(0, 80)
}